export default "__VITE_ASSET__xQZRWEPp__"